import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import './DomainsTableItem.scss';

const b = block('domains-table-item-desktop');

const DomainsTableItem = ({ data, openModal }) => {
  const locale = useSelector(state => state.locale.locale);

  const { domainName, status, createdAt, comment } = data;

  if (openModal) {
    return (
      <div className={b({ isRequest: !!openModal })}>
        <div className={b('value')}>{domainName}</div>
        <div className={b('value')}>{dayjs(createdAt).format('DD.MM.YYYY')}</div>
        <div
          onClick={() => openModal({ isOpen: true, type: 'request', domainRequestText: comment })}
          className={b('value', { clickable: true })}>
          {comment}
        </div>
        <div className={b('value', { [status.toLowerCase()]: true, capitalize: true })}>{status.toLowerCase()}</div>
      </div>
    );
  }

  return (
    <div className={b({ isRequest: !!openModal })}>
      <div className={b('left')}>
        {/* <div className={b('label')}>{openModal ? locale.domainRequested : locale.domain}</div> */}
        <div className={b('value')}>{domainName}</div>
      </div>
      <div className={b('right')}>
        {/* <div className={b('label')}>{locale.date}</div> */}
        <div className={b('value')}>{createdAt}</div>
      </div>
      {/* {openModal && (
        <>
          <div className={b('separator')} />
          <div
            onClick={() => comment && openModal({ isOpen: true, type: 'request', domainRequestText: comment })}
            className={b('left')}>
            <div className={b('label')}>{locale.comment}</div>
            <div className={b('value')}>{comment}</div>
          </div>
          <div className={b('right')}>
            <div className={b('label')}>{locale.status}</div>
            <div className={b('value', { [status.toLowerCase()]: true })}>{status.toLowerCase()}</div>
          </div>
        </>
      )} */}
    </div>
  );
};

export default DomainsTableItem;
